import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel,
	FormControl
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { adminCreateFeeMapping } from "../../redux/actions/adminCreateFeeMappingAction";
import { adminGetFeeMapping } from "../../redux/actions/adminGetFeeMappingAction";
import { getRoleList } from "../../redux/actions/getRoleListAction";
import { getMappingRoleList } from "../../redux/actions/getMappingRoleListAction";
import { createRoleMapping } from "../../redux/actions/createRoleMappingAction";
import { deleteRoleMapping } from "../../redux/actions/deleteRoleMappingAction";
import { getEntityMappingList } from "../../redux/actions/getEntityMappingListAction";
import { getEntityTypeList } from "../../redux/actions/getEntityTypeListAction";
import { createEntityMappingList } from "../../redux/actions/createEntityMappingAction";
import { deleteEntityMappingList } from "../../redux/actions/deleteEntityMappingAction";
import { addOrUpdateEntityTypeList } from "../../redux/actions/addOrUpdateEntityTypeListAction";
import { getLoadLimitList } from "../../redux/actions/getLoadLimitListAction";
import { addOrUpdateLoadLimit } from "../../redux/actions/addOrUpdateLoadLImitAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import BackButton from "../../components/BackButton/BackButton";
import { getFeeNameList } from "../../redux/actions/getFeeNameListAction";
import val from "../../getThemeDetails";
import clsx from "clsx";
// import { makeStyles, useTheme } from '@mui/styles';
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
// import Checkbox from '@mui/material/Checkbox';
// import Chip from "@mui/material/Chip";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete from "@mui/lab/Autocomplete";
import { AdmingetCustomerIDNAMELists } from "../../redux/actions/adminGetCustomerIdAndNameListAction";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AdminFeeMapping = () => {
	const [walletOwnerId, setWalletOwnerId] = useState("");
	const [fee, setFee] = useState("");
	const [searchWalletOwnerId, setSearchWalletOwnerId] = useState("");
	const [role, setRole] = useState("");
	const [entityType, setEntityType] = useState("");
	const [page, setPage] = useState(0);
	const [Open, setOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);

	const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
	const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);

	const [createFeeMappingStatus, setCreateFeeMappingStatus] = useState("");
	const [createFeeMappingResArray, setCreateFeeMappingResArray] = useState([]);

	const [getFeeMappingStatus, setGetFeeMappingStatus] = useState(false);
	const [getFeeMappingResArray, setGetFeeMappingResArray] = useState([]);

	const [getRoleStatus, setGetRoleStatus] = useState(false);
	const [getRoleResArray, setGetRoleResArray] = useState([]);

	const [getRoleMappingStatus, setGetRoleMappingStatus] = useState(false);
	const [getRoleMappingResArray, setGetRoleMappingResArray] = useState([]);

	const [getEntityTypeStatus, setGetEntityTypeStatus] = useState(false);
	const [getEntityTypeResArray, setGetEntityTypeResArray] = useState([]);

	const [createRoleMappingStatus, setCreateRoleMappingStatus] = useState("");
	const [createRoleMappingResArray, setCreateRoleMappingResArray] = useState(
		[]
	);

	const [deleteRoleMappingStatus, setDeleteRoleMappingStatus] = useState("");
	const [deleteRoleMappingResArray, setDeleteRoleMappingResArray] = useState(
		[]
	);

	const [mappingId, setMappingId] = useState("");
	const [customerId, setCustomerId] = useState("");
	const [dataAutocompleteCustID, setDataAutocompleteCustID] = useState([]);
	const [boolCustIDSet, setBoolCustIDSet] = useState(false);

	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const getWalletOwnerIdRes = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);

	const createFeeMappingRes = useSelector(
		({ adminCreateFeeMapping }) => adminCreateFeeMapping
	);

	const getFeeMappingRes = useSelector(
		({ adminGetFeeMapping }) => adminGetFeeMapping
	);

	const getRoleListRes = useSelector(({ getRoleList }) => getRoleList);

	const getEntityTypeListRes = useSelector(
		({ getEntityTypeList }) => getEntityTypeList
	);

	const getRoleMappingListRes = useSelector(
		({ getMappingRoleList }) => getMappingRoleList
	);

	const createRoleMappingRes = useSelector(
		({ createRoleMapping }) => createRoleMapping
	);

	const deleteRoleMappingRes = useSelector(
		({ deleteRoleMapping }) => deleteRoleMapping
	);
	const admingetCustomerIDandNameListRes = useSelector(
		({ adminGetCustomerIDAndNamesLists }) => adminGetCustomerIDAndNamesLists
	);

	const getFeeNameListRes = useSelector(({ getFeeNameList }) => getFeeNameList);

	const handleNoticationClose = () => {
		setWalletOwnerId("");
		setFee("");
		setCustomerId("");
		setCreateRoleMappingResArray([]);
		setDeleteRoleMappingResArray([]);
		setRole("");
		setNotificationOpen(false);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "walletOwnerId") {
			setWalletOwnerId(value == "Select Owner ID" ? "" : value);
		}

		if (name === "fee") {
			setFee(value);
		}

		if (name === "searchWalletOwnerId") {
			setSearchWalletOwnerId(value == "Select Owner ID" ? "" : value);
		}
	};

	const createFeeMappingReq = () => {
		var feeItemArray = [];
		fee.forEach((item) => {
			feeItemArray.push(item.split("-")[0]);
		});
		setCreateFeeMappingStatus(true);
		let req = {
			walletOwnerId: walletOwnerId.split("-")[0],
			feeIdList: feeItemArray,
			customerId: customerId ? customerId.split("-")[0] : "",
		};
		dispatch(adminCreateFeeMapping(req, authToken));
	};

	const createFeeMappingStatusFunc = () => {
		// console.log(getRole/MappingListRes, "/////////////////////////");
		if (createFeeMappingStatus) {
			if (createFeeMappingRes.data.status == "success") {
				setCreateFeeMappingResArray(createFeeMappingRes.data);
				setNotificationOpen(true);
				setWalletOwnerId("");
				setFee("");
				setCustomerId("");
				getFeeMappingReq();
				// getRoleMappingListReq();
			}
			if (createFeeMappingRes.data.status == "failed") {
				setCreateFeeMappingResArray(createFeeMappingRes.data);
				setNotificationOpen(true);
				if (
					createFeeMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createFeeMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (createFeeMappingRes.data.status == "INVALID REQUEST") {
				setCreateFeeMappingResArray(createFeeMappingRes.data);
				setNotificationOpen(true);
			}
		}
	};

	useEffect(() => {
		createFeeMappingStatusFunc();
	}, [createFeeMappingRes.data.status]);

	const getFeeMappingReq = () => {
		setIsLoading(true);
		setGetFeeMappingStatus(true);
		let req = {
			// adminId: 2,
			adminId: val.adminIDS,
			walletOwnerId: searchWalletOwnerId.split("-")[0]
		};
		dispatch(adminGetFeeMapping(req, authToken));
	};

	const getFeeMappingStatusFunc = () => {
		if (getFeeMappingStatus) {
			setIsLoading(false);
			if (getFeeMappingRes.data.status == "success") {
				setGetFeeMappingResArray(
					[].concat(getFeeMappingRes.data.feeMasterDetailsVOList)
				);
			}
			if (getFeeMappingRes.data.status == "failed") {
				setGetFeeMappingStatus(false);
				setGetFeeMappingResArray(getFeeMappingRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getFeeMappingRes.data.description || getFeeMappingRes.description
				);
				if (
					getFeeMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getFeeMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getFeeMappingRes.data.status == "NOT FOUND") {
				setGetFeeMappingStatus(false);
				setGetFeeMappingResArray(getFeeMappingRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getFeeMappingRes.data.description || getFeeMappingRes.description
				);
			}
		}
	};

	useEffect(() => {
		getFeeMappingStatusFunc();
	}, [getFeeMappingRes.data.status]);

	const getWalletOwnerIdStatusFunc = () => {
		if (getWalletOwnerIdStatus) {
			if (getWalletOwnerIdRes.data.status == "success") {
				setGetWalletOwnerIdResArray(
					[].concat(getWalletOwnerIdRes.data.ownerList)
				);
			}
			if (getEntityTypeListRes.data.status == "failed") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getEntityTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getEntityTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getWalletOwnerIdAndNameListReq = () => {
		setGetWalletOwnerIdStatus(true);
		dispatch(
			getWalletOwnerIdAndNameList(
				{
					loginDetails: {
						// adminId: "2"
						adminId: val.adminIDS
					}
				},
				authToken
			)
		);
	};

	// useEffect(() => {
	// 	getWalletOwnerIdAndNameListReq();
	// }, []);

	useEffect(() => {
		getWalletOwnerIdStatusFunc();
	}, [getWalletOwnerIdRes.data.status]);

	const getRoleListStatusFunc = () => {
		if (getRoleStatus) {
			if (getRoleListRes.data.status == "success") {
				setGetRoleResArray([].concat(getRoleListRes.data.roleList));
			}
			if (getRoleListRes.data.status == "failed") {
				setGetRoleResArray(getRoleListRes.data);
				if (
					getRoleListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRoleListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getRoleListReq = () => {
		setGetRoleStatus(true);
		dispatch(
			getRoleList(
				{
					ownerMasterRequestVO: {
						// adminId: 2
						adminId: val.adminIDS
					}
				},
				authToken
			)
		);
	};

	useEffect(() => {
		getRoleListReq();
	}, []);

	useEffect(() => {
		getRoleListStatusFunc();
	}, [getRoleListRes.data.status]);

	const getEntityListStatusFunc = () => {
		if (getEntityTypeStatus) {
			if (getEntityTypeListRes.data.status == "success") {
				setGetEntityTypeResArray([].concat(getEntityTypeListRes.data.roleList));
			}
			if (getEntityTypeListRes.data.status == "failed") {
				setGetEntityTypeResArray(getEntityTypeListRes.data);
				if (
					getEntityTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getEntityTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getEntityListStatusFunc();
	}, [getEntityTypeListRes.data.status]);

	const getEntityTypeListReq = () => {
		setGetEntityTypeStatus(true);
		dispatch(
			getEntityTypeList(
				{
					ownerMasterRequestVO: {
						// adminId: 2,
						adminId: val.adminIDS,
						entityType: entityType
					}
				},
				authToken
			)
		);
	};

	useEffect(() => {
		getEntityTypeListReq();
	}, []);

	const getRoleMappingListReq = () => {
		setOpen(false);
		setGetRoleMappingStatus(true);
		dispatch(
			getMappingRoleList(
				{
					ownerMasterRequestVO: {
						// adminId: 2
						adminId: val.adminIDS
					}
				},
				authToken
			)
		);
	};

	useEffect(() => {
		getRoleMappingListReq();
	}, []);

	const getRoleMappingStatusFunc = () => {
		if (getRoleMappingStatus) {
			if (getRoleMappingListRes.data.status == "success") {
				setGetRoleMappingResArray(
					[].concat(getRoleMappingListRes.data.roleList)
				);
			}
			if (getRoleMappingListRes.data.status == "failed") {
				setGetRoleMappingResArray(getRoleMappingListRes.data);
				if (
					getRoleMappingListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRoleMappingListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getRoleMappingStatusFunc();
	}, [getRoleMappingListRes.data.status]);

	const createRoleMappingReq = () => {
		setCreateRoleMappingStatus(true);
		const createMappingReq = {
			ownerMasterRequestVO: {
				// adminId: 2,
				adminId: val.adminIDS,
				ownerID: walletOwnerId.split("-")[0],
				roleName: role
			}
		};
		dispatch(createRoleMapping(createMappingReq, authToken));
	};

	const createRoleMappingStatusFunc = () => {
		console.log(getRoleMappingListRes, "/////////////////////////");
		if (createRoleMappingStatus) {
			if (createRoleMappingRes.data.status == "success") {
				setCreateRoleMappingResArray(createRoleMappingRes.data);
				setNotificationOpen(true);
				getRoleMappingListReq();
			}
			if (createRoleMappingRes.data.status == "failed") {
				setCreateRoleMappingResArray(createRoleMappingRes.data);
				setNotificationOpen(true);
				if (
					createRoleMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createRoleMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (createRoleMappingRes.data.status == "INVALID REQUEST") {
				setCreateRoleMappingResArray(createRoleMappingRes.data);
				setNotificationOpen(true);
			}
		}
	};

	useEffect(() => {
		createRoleMappingStatusFunc();
	}, [createRoleMappingRes.data.status]);

	const deleteEntityMappingReq = () => {
		setDeleteRoleMappingStatus(true);
		const deleteMappingReq = {
			ownerMasterRequestVO: {
				// adminId: 2,
				adminId: val.adminIDS,
				mappingId: mappingId
			}
		};
		dispatch(deleteRoleMapping(deleteMappingReq, authToken));
	};

	console.log(deleteRoleMappingRes, "////////////////////");

	const deleteRoleMappingStatusFunc = () => {
		console.log(deleteRoleMappingRes, "////////////////////1");
		if (deleteRoleMappingStatus) {
			console.log(deleteRoleMappingRes, "////////////////////2");
			if (deleteRoleMappingRes.data.status == "success") {
				setDeleteRoleMappingResArray(deleteRoleMappingRes.data);
				console.log(deleteRoleMappingRes, "////////////////////3");
				setNotificationOpen(true);
				getRoleMappingListReq();
			}
			if (deleteRoleMappingRes.data.status == "failed") {
				setDeleteRoleMappingResArray(deleteRoleMappingRes.data);
				setNotificationOpen(true);
				if (
					deleteRoleMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					deleteRoleMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		deleteRoleMappingStatusFunc();
	}, [deleteRoleMappingRes.data.status]);

	// GetFeeNameList Start

	const getFeeNameListReq = () => {
		// setIsLoading(true);
		//setGetFeeMappingStatus(true);
		let req = {
			// adminId: 2
			adminId: val.adminIDS
		};
		dispatch(getFeeNameList(req, regenerateTokenRes.data.AuthToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getFeeNameListReq();
			getFeeMappingReq();
			getWalletOwnerIdAndNameListReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	// GetFeeNameList End

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setMappingId("");
		setOpen(false);
	};

	const deleteEntity = (mappingid) => {
		setMappingId(mappingid);
		setOpen(true);
	};

	const filterOptionsL = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}
		const filterOptionsList = options.filter(
			(option) => option.includes(inputValue) || ""
		);
		return filterOptionsList.slice(0, 20);
	};

	useEffect(() => {
		setCustomerId("");
		if (walletOwnerId) {
			const getCustomerIdAndNameReq = {
				actionCustomerMasterRequestVO: {
					customerNameOrId: "",
					walletOwnerId: walletOwnerId.split("-")[0],
				},
			};
			dispatch(AdmingetCustomerIDNAMELists(getCustomerIdAndNameReq, authToken));
			setBoolCustIDSet(true);
		}
	}, [walletOwnerId]);

	const setDataAutocompleteCustIdFunc = () => {
		if (boolCustIDSet) {
			if (
				admingetCustomerIDandNameListRes.data.status === "Success" ||
				admingetCustomerIDandNameListRes.data.status === "success"
			) {
				setDataAutocompleteCustID(
					admingetCustomerIDandNameListRes.data.customerList
				);
			}
			if (
				admingetCustomerIDandNameListRes.data.status === "Failed" ||
				admingetCustomerIDandNameListRes.data.status === "failed"
			) {
				setDataAutocompleteCustID([]);
				if (admingetCustomerIDandNameListRes.data.description == "session out") {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					admingetCustomerIDandNameListRes.data.description ==
					"Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (admingetCustomerIDandNameListRes.data.status === "Not found") {
				setDataAutocompleteCustID([]);
			}
		}
	};

	useEffect(() => {
		setDataAutocompleteCustIdFunc();
	}, [admingetCustomerIDandNameListRes.data.status]);

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<DialogTitle>Create Mapping</DialogTitle>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item sm={12} md={4} lg={4}>
							<TextField
								required
								select
								size="small"
								color="primary"
								type="text"
								label="Owner ID"
								variant="standard"
								fullWidth={true}
								name="walletOwnerId"
								// value={walletOwnerId || ""}
								defaultValue={"Select Owner ID" || walletOwnerId}
								onChange={handleChange}
							>
								<MenuItem value="Select Owner ID" selected="Owner ID">
									Select Owner ID
								</MenuItem>
								{getWalletOwnerIdRes.data.ownerList &&
									[]
										.concat(getWalletOwnerIdResArray)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>
						{/* NEW: Customer ID field */}
						<Grid item sm={12} md={4} lg={4}>
							<Autocomplete
								id="customer-id-combo-box"
								size="small"
								options={[].concat(dataAutocompleteCustID || [""])}
								getOptionLabel={(option) => option}
								filterOptions={filterOptionsL}
								value={customerId}
								onChange={(event, value) => setCustomerId(value || "")}
								renderInput={(params) => (
									<TextField
										{...params}
										label="Merchant ID"
										variant="standard"
										fullWidth
										style={{ marginTop: "3px" }}
										sx={{
											"& .MuiInput-underline:before": {
												borderBottomColor: "gray",
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												borderBottomColor: "gray",
											},
											"& .MuiInput-underline:after": {
												borderBottomColor: "gray",
											},
										}}
									/>
								)}
							/>
						</Grid>
						<Grid item sm={12} md={4} lg={4}>
							{/* <TextField
								required
								select
								size="small"
								color="primary"
								type="text"
								label="Fee"
								fullWidth={true}
								name="fee"
								defaultValue={"Select Fee" || fee}
								onChange={handleChange}
							>
								<MenuItem value="Select Fee" selected="Select Fee">
									Select Fee
								</MenuItem>
								{getFeeNameListRes.data &&
									getFeeNameListRes.data.currencyList &&
									[].concat(getFeeNameListRes.data.currencyList).map((item) => (
										<MenuItem value={item}>{item}</MenuItem>
									))}
							</TextField> */}
							<FormControl
								className={classes.formControl}
								style={{ width: "100%", marginTop: "-3px" }}
							>
								<InputLabel id="demo-mutiple-checkbox-label">Fee</InputLabel>
								<Select
									labelId="demo-mutiple-checkbox-label"
									id="demo-mutiple-checkbox"
									multiple={true}
									name="fee"
									value={fee || []}
									onChange={handleChange}
									input={<Input />}
									renderValue={(selected) => selected.join(", ")}
									MenuProps={MenuProps}
								>
									{getFeeNameListRes.data &&
										getFeeNameListRes.data.currencyList &&
										[]
											.concat(getFeeNameListRes.data.currencyList)
											.map((name) => (
												<MenuItem key={name} value={name}>
													<Checkbox
														color="primary"
														checked={fee.indexOf(name) > -1}
													/>
													<ListItemText primary={name} />
												</MenuItem>
											))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item sm={12} md={4} lg={4}>
							{/* <Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								variant="contained"
								onClick={createFeeMappingReq}
							>
								Create
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={createFeeMappingReq}

							>
								Create
							</CustomButton>
						</Grid>
					</Grid>
				</Card>
				<Card>
					<DialogTitle>Search Mapping</DialogTitle>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Owner ID"
								variant="standard"
								fullWidth={true}
								name="searchWalletOwnerId"
								// value={walletOwnerId || ""}
								defaultValue={"Select Owner ID" || searchWalletOwnerId}
								onChange={handleChange}
							>
								<MenuItem value="Select Owner ID" selected="Owner ID">
									Select Owner ID
								</MenuItem>
								{getWalletOwnerIdRes.data.ownerList &&
									[]
										.concat(getWalletOwnerIdResArray)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item sm={12} md={4} lg={4}>
							{/* <Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								variant="contained"
								onClick={getFeeMappingReq}
							>
								Search
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getFeeMappingReq}

							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getFeeMappingResArray.length == undefined ||
					getFeeMappingResArray.status == "NOT FOUND" ||
					!getFeeMappingStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1"> </Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<TableContainer component={Paper} className="my-3">

						<Table
							className={classes.table}
							size="small"
							aria-label="a dense table"
						>
							<TableHead>
								<TableRow className="tableHeaderColor">


									{/* <TableRow style={{ background: "#00b9f5" }}> */}
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Fee Mapping Id
									</TableCell>
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Owner Name
									</TableCell>
									<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
										Merchant ID
									</TableCell>
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Fee Name
									</TableCell>
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Category
									</TableCell>
									{/* <TableCell align="center">Category</TableCell> */}
								</TableRow>
							</TableHead>

							<TableBody>
								{getFeeMappingResArray &&
									[]
										.concat(getFeeMappingResArray)
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((row, index) => (
											<TableRow>
												<TableCell align="center">{row.feeMappingId}</TableCell>
												<TableCell align="center">
													{row.walletOwnerName}
												</TableCell>
												<TableCell align="center">
													{row.customerId || row.customerId === "" ? row.customerId : "-"}
												</TableCell>
												<TableCell align="center">{row.feeName}</TableCell>
												<TableCell
													style={{
														padding: "8px"
													}}
													align="center"
												>
													{row.category}
												</TableCell>
												{/* <TableCell align="center">
													<CustomButton
														style={{
															padding: "8px"
														}}
														// onClick={() => deleteEntity(row.operationId)}
													>
														Delete
													</CustomButton>
												</TableCell> */}
											</TableRow>
										))}
							</TableBody>
						</Table>
						<TablePagination
							rowsPerPageOptions={[5, 10, 25]}
							component="div"
							count={getFeeMappingResArray.length}
							rowsPerPage={rowsPerPage}
							page={page}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
						/>
					</TableContainer>
				)}
			</Layout>

			{createFeeMappingResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createFeeMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{createFeeMappingResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createFeeMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{createFeeMappingResArray.status == "INVALID REQUEST" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createFeeMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteRoleMappingResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteRoleMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteRoleMappingResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteRoleMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AdminFeeMapping;
